import React from "react";
import "./client-logo.css";

const logos = [
  { src: "/assets/images/client-logos/aws-logo.png", scale: 0.8 },
  { src: "/assets/images/client-logos/sap-logo.png", scale: 1 },
  { src: "/assets/images/client-logos/epicsai-logo.png", scale: 1 },
  { src: "/assets/images/client-logos/Microsoft-logo.png", scale: 1.1 },
  { src: "/assets/images/client-logos/under-armour-logo-bg.webp", scale: 0.6 },
  { src: "/assets/images/client-logos/koncept-house-logo.png", scale: 1.2 },
  { src: "/assets/images/client-logos/Intellectt_logo.webp", scale: 1.1 },
  { src: "/assets/images/client-logos/deckers_logo.webp", scale: 1 },
  { src: "/assets/images/client-logos/mec-logo.png", scale: 1.2 },
  { src: "/assets/images/client-logos/outside-digital-logo-bg.webp", scale: 1 },
  { src: "/assets/images/client-logos/axiss-logo.png", scale: 0.8 },
  { src: "/assets/images/client-logos/proleads-logo.png", scale: 1 },
  { src: "/assets/images/client-logos/mapmyfitness-logo-bg.webp", scale: 1 }
];

const ClientLogos = () => {
  return (
    <div className="client-logos-section">
      <div className="logos-container">
        <div className="logos-track">
          {[...logos, ...logos].map((logo, index) => (
            <div className="logo-item" key={index}>
              <img
                src={logo.src}
                alt={`Client ${index + 1}`}
                style={{
                  transform: `scale(${logo.scale})`,
                }}
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default ClientLogos;